import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.reduce";
import PopperJs from 'popper.js';
export var DELAY_OPEN = 250; // ms

export var PLACEMENT = PopperJs.placements.sort().reduce(function (acc, placement) {
  acc[placement] = placement;
  return acc;
}, {});